// extracted by mini-css-extract-plugin
export default {"ctr":"AddSockets_ctr__+39vg"};